import { render, staticRenderFns } from "./newWeixinLogin.vue?vue&type=template&id=7e954a8d&scoped=true&"
import script from "./newWeixinLogin.vue?vue&type=script&lang=js&"
export * from "./newWeixinLogin.vue?vue&type=script&lang=js&"
import style0 from "./newWeixinLogin.vue?vue&type=style&index=0&id=7e954a8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e954a8d",
  null
  
)

export default component.exports